var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Loading',{staticClass:"loading-app--wrapper",attrs:{"showSpinner":_vm.showSpinner,"text":_vm.messageError,"showText":!_vm.showSpinner}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }